export const i18nKeys = ["tw", "en"]
